'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.accordion = twentyninetimes.accordion || function () {

	function init() {
		const accordions = document.querySelectorAll('.js-accordion');

		if ( accordions ) {
			for (var i = 0; i < accordions.length; i++) { 
				let accordion = accordions[i];

				accordionToggle(accordion);
			}
		}
	}

	function accordionToggle(accordion) {
		var accordionToggle 	= accordion.querySelector('.js-accordion-toggle'),
			accordionContent 	= accordion.querySelector('.js-accordion-content');

		accordionToggle.addEventListener('click', function(event) {
			event.stopPropagation();

			let expanded = accordionToggle.getAttribute('aria-expanded') === 'true' || false;
			accordionToggle.setAttribute('aria-expanded', !expanded);

			var svg = accordion.querySelectorAll('.accordion__svg .path');

		    if ( !accordion.classList.contains('active') ) {
		    	accordion.classList.add('active');

		    	accordionContent.style.height = 'auto';
		    	var accordionHeight = accordionContent.clientHeight;
		    	accordionContent.style.height = '0px';

		    	setTimeout(function () {
		    		accordion.classList.add('active');
		    		accordionContent.style.height = accordionHeight + 'px';

		    		setTimeout(function () {
		    			if ( accordion.classList.contains('active') ) {
		    				accordionContent.style.height = 'auto';
		    			}
		    		}, 600);
		    	}, 10);
		    	
		    } else {
		    	var accordionHeight = accordionContent.clientHeight;
		    	accordionContent.style.height = accordionHeight + 'px';

		    	setTimeout(function () {
		    		accordionContent.style.height = '0px';
		    		accordion.classList.remove('active');				
		    	}, 10);
		    }
		});
	}

	return {
		init : init
	};

}();